import { upload } from "@testing-library/user-event/dist/upload";

export const urls = {
  admin: {
    uploadCsvData: "/admin/uploadZipFile",
    getInternalId: "/admin/getUserDataInternalIds",
    mapInterIdsWithSheetIds: "/admin/mapInterIdsWithSheetIds",
    updateMappingData: "/admin/updateMappingData",
    createAutoInvigilatorForCenter: "/admin/createAutoInvigilatorForCenter",
    getMappings: "/admin/getMappings",
    getColumnData: "/admin/getColumnData",
    getAllUploadedFiles: "/admin/getAllUploadedFiles",
    getAssignedInviliatorCount: "/admin/getAssignedInviliatorCount",
    updateInvigilatorsCounts: "/admin/updateInvigilatorsCounts",
    confirmInvigilator: "/admin/confirmNoOfInvigilatorsForCenters",
    createCSVForInvigilators: "/admin/createCSVForInvigilators",
    uploadInvigilatorSheetForPasswordCreation:
      "/admin/uploadInvigilatorSheetForPasswordCreation",
    getAllExamName: "/admin/getAllExamName",
    getCSRReport: "/admin/getCSRReportById",
    getPastUploads: "/admin/getPastUploads",
    getExamShifts: "/admin/getExamShifts",
    getShiftData: "/admin/getExamShifts",
    getVerificationData: "/admin/getVerification",
    getCountData: "/stats/countInfo",

    getZones: "/stats/uniqueZones",
    getStates: "/stats/uniqueStates",
    getDistricts: "/stats/uniqueCities",
    getCenters: "/stats/uniqueCenters",
    getUsers: "/stats/getUsers",

    getAllClient: "/admin/getAllClient",
    getAllOperator: "/admin/reverification/user/get-all",
    createClient: "/admin/createClient",
    createOperator: "/admin/reverification/user/create",
    resetClientPassword: "/admin/resetPassword",
    resetOperatorPassword: "/admin/resetPassword",
    deleteOperator: "/admin/reverification/user/delete",
    deleteClient: "/admin/deleteClient",
    toggleActiveUser: "/admin/reverification/user/toggle-active",

    deleteShift: "/admin/deleteShift",
    checkIfFieldsExist: "/admin/checkFileMappingStep2",
    downloadVerifiedUsers: "/admin/verifiedZip",
    createStudent: "/admin/user/create",

    toggleOfflineExam: "/admin/exam/toggleOffline",
    getStatsByExamShift: "/admin/stats/get",
    getInstructorByExamShift: "/admin/invigilators/get",

    getInvigilatorLogs: "/admin/invigilators/login/logs",
    getReverificationUser: "/admin/reverification/user/get",
    updateReverificationUser: "/admin/reverification/user/update",
    downloadRecordsWithNoVerification: "/admin/student/recordsWithNoVerification",
    uploadReverficationSheet: "/admin/reverification/user/add-students",
    getReverificationData: "/admin/reverification/user/get",
    getAssignedUsers: "/admin/reverification/user/assigned",

    uploadReverficationUserSheet: "/admin/reverification/students/upload-csv",
    uploadReverficationOperatorSheet: "/admin/reverification/operator/upload-csv",
    getClinetById: "/admin/client",
    getClientPages: "/admin/client/pages",
    updateClient: "/admin/client/update",
    resetPasswordReverificationOperator: "/admin/reverification/user/reset-password",
  },

  getUniqueCenters: "/admin/getUniqueCenters",
  addInstructor: "/admin/createSingleInvigilator",

  exam: {
    createExam: "/exam/createExam",
    allExams: "/exam/getAllExam",
    getAllExamById: "/exam/getExamById",
    getAllEnumsForVerfication: "/exam/getAllEnumsForVerification",
    getExamSetting: "/exam/getExamSettings",
    updateExamSettings: "/exam/updateExamSettings",
    addexamShiifts: "/exam/addShiftToExam",
    toggleExamIsLive: "/exam/toggleExamIsLive",
    updateShifts: "/exam/updateShifts",
    deleteExam: "/exam/deleteExam",
    addShiftsByExamId: "/exam/addShifts",
    updateShift: "/exam/shift/update",
    toggleShiftIsBiometricAllowed: "/exam/shift/toggle-login",
    createApiKey: "/exam/api-key/create"
  },

  profile: {
    getUserRoles: "/profile/getUserRoles",
    getAllQuestiontypes: "/profile/getAllQuestiontypes",
    getAllSubjects: "/profile/getAllSubjects",
  },
  public: {
    userLogin: "/admin/login",
    getLanguage: "/public/getAllLanguage",
  },
  users: {
    getAllUsers: "/users/getAllUsers",
    changeUserRole: "/users/updateUserRole",
    blockUnblockUser: "/users/blockUnblockUser",
    userUpdate: "/users/userUpdate",
    register: "/users/register",
  },
  request: {
    getLogs: "/request/getLogs",
  },
  subjects: {
    insert: "/subject/insert",
    update: "/subject/update",
  },
  upload: {
    uploadMultimedia: "/upload/uploadMultimedia",
    uploadQuestion: "/upload/uploadQuestion",
  },
  qp_generation: {
    checkQuestionAvailability: "/qpgeneration/checkQuestionAvailability",
  },

  stats: {
    getSyncupData: "/stats/getSyncupData",
    getCentersWSRReportStatus: "/stats/getCentersWSRReportStatus",
    getAuthUsersOnline: "/stats/getAuthUsersOnline",
    getFailuresCount: "/stats/getFailuresCount",
    getAuthenticationsDone: "/stats/getAuthenticationsDone",
    totalCSRCount: "/stats/totalCSRCount",
    totalExamCount: "/stats/totalExamCount",
    totalLiveExamsCount: "/stats/totalLiveExamsCount",
    getInvigilatorsStats: "/admin/invi/stats",
  },

  versions: {
    getVersions: "/admin/versions/get/all",
    createVersion: "/admin/versions/create",
    markCurrent: "/admin/versions/mark/current",
    markObsolete: "/admin/versions/mark/obsolete",
    updateLink: "/admin/versions/update/link",
  },

  export: {
    get: "/admin/exports",
    userUnmatchedImagesPdf: "/admin/export/userImages",
    userVerfications: "/admin/export/userVerifications",
    userDataCSV: "/admin/export/userDataCSV",
    topInvigilators: "/admin/invigilators/downloadstats",
    timelyInvigilators: "/admin/invigilators/time-verfications",
    absentCandidates: "/admin/csv/create/student/absent",
    invigilatorLoginTimes: "/admin/csv/create/inv/login",
    invigilatorDownloadStats: "/admin/csv/create/inv/stats",
    downloadNotStarted: "/admin/csv/inv/not-login",
    irisExamCsv: "/admin/export/iris-csv",
    irisExamData: "/admin/export/iris-verifications",
    biometricNotStarted: "/admin/csv/biometric-not-started-centers",
    centersNotSynced: "/admin/csv/not-synced-centers",
  },

  file: {
    upload: "/admin/upload/file"
  },

  mock: {
    createMockExam: "/admin/create-mock-data"
  },

  adminV2: {
    getCenters: "/api/v2/admin/center/get/all",
    getCenterInvList: "/api/v2/admin/center-inv/get/all",
    createCenterInvList: "/api/v2/admin/center-inv/create",

    getExamMapping:"/api/v2/admin/mhcet/mappings",
    getVendorSessions:"/api/v2/admin/mhcet/vendors/sessions",
    createMhcetMapping:"/api/v2/admin/mhcet/shift/mapping",
    updateMhcetMapping:"/api/v2/admin/mhcet/shift/mapping",
    getShiftExport:"/api/v2/admin/mhcet/mark-attendance/status",
    startSync:"/api/v2/admin/mhcet/mark-attendance"
  
  }
};